import { BrandAvatar } from "@faire/retailer-visitor-shared/components/BrandAvatar/index";
import { ComponentWithLoadingFallback } from "@faire/retailer-visitor-shared/components/GhostLoading/ComponentWithLoadingFallback";
import { GhostBlock } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostBlock";
import { BrandSearchContext } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/BrandSearchContext";
import { getSpacing } from "@faire/web/slate/spacing";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import React, { useContext } from "react";
import { Link } from "react-router-dom";

export const BrandImage: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const { brandPagePath, handleBrandClick, brand } =
    useContext(BrandSearchContext);
  const imgDesktopDimension = getSpacing("8x");

  return (
    <ComponentWithLoadingFallback
      fallback={
        <ResponsiveContentV2
          mobile={
            <GhostBlock
              $width={getSpacing("8x")}
              $height={getSpacing("8x")}
              $borderRadius="50%"
            />
          }
          tabletAndAbove={
            <GhostBlock
              $width={imgDesktopDimension}
              $height={imgDesktopDimension}
              $borderRadius="50%"
            />
          }
        />
      }
      isLoading={isLoading}
    >
      <Link to={brandPagePath} onClick={handleBrandClick("brandImage")}>
        <ResponsiveContentV2
          mobile={
            <BrandAvatar
              image={brand?.profile_image}
              size="large"
              displayTooltip
              isTopShop={brand?.is_top_shop}
              hideIcon
            />
          }
          tabletAndAbove={
            <BrandAvatar
              image={brand?.profile_image}
              size="large"
              displayTooltip
              isTopShop={brand?.is_top_shop}
            />
          }
        />
      </Link>
    </ComponentWithLoadingFallback>
  );
};
